export default "__VITE_ASSET__C$vNDsE1__"